/**
 * Which page — and where on it — a viewport point is over.
 *
 * Dragging an object keeps the pointer captured by the page it started on, so
 * that page cannot see the others. Every mounted page registers how to turn a
 * viewport point into its own page space; a drag asks all of them where it is
 * about to land.
 */
const pages = new Map();

export function registerPageDropTarget(uid, fn) {
    pages.set(uid, fn);
    return () => {
        if (pages.get(uid) === fn) pages.delete(uid);
    };
}

/** `{ uid, point }` for the page under the point (page-space `point`), or null between pages. */
export function pageAtPoint(clientX, clientY) {
    for (const [uid, fn] of pages) {
        const point = fn(clientX, clientY);
        if (point) return { uid, point };
    }
    return null;
}
